import Vue from 'vue'
import Router from 'vue-router'
import NarrativeTemplate from "./components/narrative/NarrativeTemplate";
import StateTemplate from "./components/state/StateTemplate";
import stateStats from "./constants/stateStats.json";

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/all',
            name: 'all',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/aapi',
            name: 'aapi',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/black',
            name: 'black',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/flipped',
            name: 'flipped',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        
        {
            path: '/gotv',
            name: 'gotv',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/latino',
            name: 'latino',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/lgbtq',
            name: 'lgbtq',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/native_american',
            name: 'native_american',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/new-dems',
            name: 'new',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/poc',
            name: 'poc',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/technology',
            name: 'technology',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/women-leaders',
            name: 'women',
            component: NarrativeTemplate,
            meta: { transitionName: 'scale-transition'}
        },
        {
            path: '/:state',
            name: 'state',
            component: StateTemplate,
            meta: { transitionName: 'scale-transition'},
            beforeEnter: (to, from, next) => {
                let stateStatsMinusUsa = { ...stateStats };
                delete stateStatsMinusUsa.USA;
                const stateList = Object.keys(stateStatsMinusUsa);
                if(stateList.includes(to.params.state.toUpperCase())){
                    next();
                } else {
                    next('/');
                }
            }
        },
        {
            path: '*',
            redirect: { name: 'all'}
        }
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})
